import React from "react";

const ExclamationMarkCircle: React.FC<React.SVGProps<SVGSVGElement>> = ({
	width = 32,
	height = 32,
	...props
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Exclamation mark circle icon"
			{...props}
		>
			<path
				d="M16 29C8.83203 29 3 23.168 3 16C3 8.83203 8.83203 3 16 3C23.168 3 29 8.83203 29 16C29 23.168 23.168 29 16 29ZM16 27C22.0859 27 27 22.0859 27 16C27 9.91406 22.0859 5 16 5C9.91406 5 5 9.91406 5 16C5 22.0859 9.91406 27 16 27ZM15 22V20H17V22H15ZM15 18V10H17V18H15Z"
				fill="#B41400"
			/>
		</svg>
	);
};

export default ExclamationMarkCircle;